import * as S from './CarouselNavigation.styles';
import { StyledCarouselNavigationProps } from './CarouselNavigation.styles';

type CarouselNavigationProps = {
  instance: any; // eslint-disable-line
  label?: string;
  children: React.ReactNode;
} & StyledCarouselNavigationProps;

const defaultProps: Partial<CarouselNavigationProps> = {
  label: '',
  motive: 'carouselNavigationPrimary',
};

export function CarouselNavigation(props: CarouselNavigationProps): React.ReactElement {
  const { instance, children, motive } = { ...defaultProps, ...props };

  return (
    <S.Container motive={motive}>
      <S.PrevButton
        type="button"
        onClick={() => instance?.current.swiper.slidePrev()}
        iconLeft="FiChevronLeft"
        scale="xl2"
        motive={motive}
        className="prev-btn"
      />

      {children}

      <S.NextButton
        type="button"
        onClick={() => instance?.current.swiper.slideNext()}
        iconLeft="FiChevronRight"
        scale="xl2"
        motive={motive}
        className="next-btn"
      />
    </S.Container>
  );
}
